import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography} from "@mui/material";
import Box from "@mui/material/Box";

const DeleteAddressDialog = ({
                                 deleteDialogOpen,
                                 handleCloseDeleteDialog,
                                 selectedAddress,
                                 deleteLoading,
                                 handleConfirmDelete,t
                             })=>{
    return (
        <>
            <Dialog
                open={deleteDialogOpen}
                onClose={handleCloseDeleteDialog}
                fullWidth
                maxWidth="xs"
                PaperProps={{
                    sx: {
                        borderRadius: "24px",
                        p: { xs: 1, sm: 2 },
                        backgroundColor: "#FCFCFC",
                        boxShadow: "0px 12px 40px rgba(0,0,0,0.12)",
                    },
                }}
            >
                <DialogTitle
                    sx={{
                        pb: 1,
                        textAlign: "center",
                    }}
                >
                    <Typography
                        sx={{
                            fontFamily: "'Zen Maru Gothic', sans-serif",
                            fontWeight: 900,
                            fontSize: { xs: "20px", md: "24px" },
                            lineHeight: "120%",
                            color: "#111111",
                        }}
                    >
                        {t("Delete address")}
                    </Typography>
                </DialogTitle>

                <DialogContent sx={{ pt: "8px !important" }}>
                    <Typography
                        sx={{
                            fontFamily: "'Zen Maru Gothic', sans-serif",
                            fontWeight: 700,
                            fontSize: "14px",
                            lineHeight: "160%",
                            textAlign: "center",
                            color: "#3A3A3A",
                            mb: 2,
                        }}
                    >
                        {t("Do you want to delete this address?")}
                    </Typography>

                    {selectedAddress && (
                        <Box
                            sx={{
                                border: "1px solid #E9E9E9",
                                borderRadius: "18px",
                                p: 2,
                                backgroundColor: "#FFFFFF",
                            }}
                        >
                            <Typography
                                sx={{
                                    fontFamily: "'Zen Maru Gothic', sans-serif",
                                    fontWeight: 900,
                                    fontSize: "13px",
                                    color: "#E5007E",
                                    mb: 1,
                                }}
                            >
                                {selectedAddress.title}
                            </Typography>

                            {selectedAddress.lines?.map((line, index) => (
                                <Typography
                                    key={index}
                                    sx={{
                                        fontFamily: "'Zen Maru Gothic', sans-serif",
                                        fontWeight: 700,
                                        fontSize: "13px",
                                        lineHeight: "150%",
                                        color: "#111111",
                                    }}
                                >
                                    {line}
                                </Typography>
                            ))}
                        </Box>
                    )}
                </DialogContent>

                <DialogActions
                    sx={{
                        px: 3,
                        pb: 3,
                        pt: 1,
                        display: "flex",
                        justifyContent: "center",
                        gap: 1.5,
                        flexWrap: "wrap",
                    }}
                >
                    <Button
                        onClick={handleCloseDeleteDialog}
                        disabled={deleteLoading}
                        sx={{
                            minWidth: "140px",
                            height: "44px",
                            borderRadius: "999px",
                            px: 3,
                            backgroundColor: "#F3F3F3",
                            fontFamily: "'Zen Maru Gothic', sans-serif",
                            fontWeight: 900,
                            fontSize: "12px",
                            color: "#111111",
                            "&:hover": {
                                backgroundColor: "#E7E7E7",
                            },
                        }}
                    >
                        {t("Cancel")}
                    </Button>

                    <Button
                        onClick={handleConfirmDelete}
                        disabled={deleteLoading}
                        sx={{
                            minWidth: "140px",
                            height: "44px",
                            borderRadius: "999px",
                            px: 3,
                            backgroundColor: "#E5007E",
                            fontFamily: "'Zen Maru Gothic', sans-serif",
                            fontWeight: 900,
                            fontSize: "12px",
                            color: "#FFFFFF",
                            "&:hover": {
                                backgroundColor: "#C8006D",
                            },
                            "&.Mui-disabled": {
                                backgroundColor: "#F4A7CF",
                                color: "#FFFFFF",
                            },
                        }}
                    >
                        {deleteLoading ? t('Delete...') : t('Yes,delete')}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}
export default DeleteAddressDialog